const VALID_SUBSCRIPTION_STATUSES = ['active', 'past_due', 'trialing', 'unpaid'];

class FeatureBillingService {
  constructor(Config) {
    this.Config = Config;
  }

  featureSummary(account, billingFeatures) {
    var flagMap = _.reduce(this.Config.accountTags, (acc, item) => {
      acc[item.value] = angular.copy(item); //copy to avoid keeping mutated value around
      return acc;
    }, {});

    this.featuresFromAccount(account).forEach((key) => {
      if (flagMap[key]) {
        flagMap[key].active = true;
      }
    });

    billingFeatures.tags.forEach((key) => {
      if (flagMap[key]) {
        flagMap[key].withPlan = true;
      }
    });

    var extraFlags = [], missingFlags = [];
    _.each(flagMap, (obj, key) => {
      if (obj.beta) {
        return;
      }
      if (obj.active && !obj.withPlan) extraFlags.push(obj);
      if (!obj.active && obj.withPlan) missingFlags.push(obj);
    });

    var supportPlanMismatch = null;
    var billedPlan = billingFeatures.support_plan;
    if (billedPlan !== null && billedPlan != account.support_plan) {
      supportPlanMismatch = {billedPlan, currentPlan: account.support_plan};
    }

    var storagePlanMismatch = null;
    var billedStorage = billingFeatures.storage_policy;
    if (billingFeatures.storage_policy != account.storage_policy || billingFeatures.storage_duration_days != account.storage_duration_days) {
      storagePlanMismatch = {
        billedPolicy: billingFeatures.storage_policy,
        currentPolicy: account.storage_policy,
        billedDurationDays: billingFeatures.storage_duration_days,
        currentDurationDays: account.storage_duration_days
      };
    }

    let streamingQualityMismatch = null;
    const billedResolutionLimit = billingFeatures.resolution_limit;
    const billedLowCost = flagMap.low_cost_plan.withPlan || false;
    const currentResolutionLimit = account.resolution_limit;
    const currentLowCost = flagMap.low_cost_plan.active || false;
    if ((billedResolutionLimit != null && billedResolutionLimit != currentResolutionLimit) || (billedLowCost != null && billedLowCost != currentLowCost)) {
      const resolutionLimitAndQualityToLabel = (rl, lc) => {
        if (rl == 480) {
          return _.find(this.Config.streamingQualityLevels, l => l.value == 'sd').label;
        } else if (rl == 720) {
          if (lc) {
            return _.find(this.Config.streamingQualityLevels, l => l.value == 'low_cost').label;
          } else {
            return _.find(this.Config.streamingQualityLevels, l => l.value == '720').label;
          }
        } else if (rl == 1080) {
          return _.find(this.Config.streamingQualityLevels, l => l.value == 'hd').label;
        } else {
          return (_.find(this.Config.streamingQualityLevels, l => l.value == '4k')||{}).label;
        }
      };
      const billedStreamingQuality = resolutionLimitAndQualityToLabel(billedResolutionLimit, billedLowCost);
      const currentStreamingQuality = resolutionLimitAndQualityToLabel(currentResolutionLimit, currentLowCost);
      streamingQualityMismatch = {billedStreamingQuality, currentStreamingQuality};
    }

    let maxDurationMismatch = null;
    const billedMaxDuration = billingFeatures.max_broadcast_duration_hrs;
    if (billedMaxDuration !== null && billedMaxDuration != account.max_broadcast_duration_hrs) {
      maxDurationMismatch = {billedMaxDuration, currentMaxDuration: account.max_broadcast_duration_hrs};
    }

    let maxSimultaneousMismatch = null;
    const billedMaxSimultaneous = billingFeatures.max_simultaneous_streams;
    if (billedMaxSimultaneous !== null && billedMaxSimultaneous != account.max_simultaneous_streams) {
      maxSimultaneousMismatch = {billedMaxSimultaneous, currentMaxSimultaneous: account.max_simultaneous_streams};
    }

    return {
      flagMap,
      extraFlags,
      missingFlags,
      supportPlanMismatch,
      storagePlanMismatch,
      streamingQualityMismatch,
      maxDurationMismatch,
      maxSimultaneousMismatch,
    };
  }

  featuresFromAccount(account) {
    var tags = account.tags.split(' ');
    tags.sort();
    return tags;
  }
  
  removeTag(tags, tag) {
    const idx = tags.indexOf(tag);
    if (idx >= 0) {
      tags.splice(idx, 1);
    }
    return tags;
  }
}


angular.module('app.services').service('FeatureBillingService', FeatureBillingService);


// WEBPACK FOOTER //
// ./services/feature_billing_service.js